import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import MyComponent from '../../../Components/MyComponent';

class ModalProductProperties extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;

        this.state = {
            resolve: _ => null,
            reject: _ => null,
            title: {
                INSERT: 'افزودن بخش',
                UPDATE: 'ویرایش بخش',
                VIEW: 'اطلاعات بخش'
            },
            bloodGroups: [
                {id: '', text: '...'},
                ...props.base.bloodGroups.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            productTypes: [
                {id: '', text: '...'},
                ...props.base.productTypes.map(item => {
                    return {id: item.id, text: item.name, data: item};
                })
            ],
            fields: {},
            error: false
        };

        this.ref = {
            modal: React.createRef(),
            insert: React.createRef(),
            bloodGroupId: React.createRef(),
            productTypeId: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        bloodGroupId: x => Boolean(x?.[0]?.id) || 'گروه خونی انتخاب نشده است.',
        productTypeId: x => Boolean(x) || 'نوع فرآورده انتخاب نشده است.'
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields;
    }

    render() {
        const {state} = this;
        let readOnly = state.action === ModalAction.VIEW;

        return <Modal ref={this.ref.modal}
                      name={'ModalProductProperties'}
                      size={'small'}
                      title={'ویژگی‌های فرآورده'}
                      error={state.error}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Select ref={this.ref.bloodGroupId} value={state.fields?.bloodGroupId} options={state.bloodGroups} className={'pad-4 fb-20'} label={'گروه خونی'} readOnly={readOnly} validation={this.validations.bloodGroupId} onChange={this.setField.bind(this, 'bloodGroupId')}/>
                    <Select ref={this.ref.productTypeId} value={state.fields?.productTypeId} options={state.productTypes} className={'pad-4 fb-20'} label={'نوع فرآورده'} readOnly={readOnly} validation={this.validations.productTypeId} onChange={this.setField.bind(this, 'productTypeId')}/>
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.submitClickHandler.bind(this)}>ثبت</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    close() {
        this.ref.modal.current.close();

        this.state.reject();

        this.props.onClose();
    }

    open(data, action) {
        return new Promise((resolve, reject) => {
            this.setState({
                resolve,
                reject,
                data,
                action,
                fields: {
                    bloodGroupId: data?.bloodGroupId ? [{id: data?.bloodGroupId}] : undefined,
                    productTypeId: data?.productTypeId ? [{id: data?.productTypeId}] : undefined
                },
                error: null
            });

            return this.ref.modal.current.open();
        });
    }

    submitClickHandler() {
        if (this.validate()) {
            this.ref.modal.current.close();

            this.state.resolve({...this.state.fields});
        }
    }

    validate() {
        const validate = Tool.validate(
            this.ref.bloodGroupId,
            this.ref.productTypeId);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalProductProperties)